import { arrayDims as n } from "./array.js";

function r(n, r) {
  return n === r;
}

function t(n, r) {
  return !(!n && r) && !(n && !r) && (n === r || n.length === r.length && n.every(function (n, t) {
    return n === r[t];
  }));
}

function e(n, r) {
  return !(!n && r) && !(n && !r) && (n === r || n[0] === r[0] && n[1] === r[1]);
}

function u(r, i) {
  if (!r && i) return !1;
  if (r && !i) return !1;
  if (!r && !i) return !0;
  if (r === i) return !0;
  if (r.length !== i.length) return !1;
  var o = n(r);
  return !!t(o, n(i)) && (2 === o.length ? r.every(function (n, r) {
    return e(n, i[r]);
  }) : 3 === o.length && r.every(function (n, r) {
    return u(n, i);
  }));
}

var i = 1e-7;

function o(n, r, t) {
  return void 0 === t && (t = 1e-7), n === r || void 0 !== n && void 0 !== r && Math.abs(n - r) < t;
}

function f(n, r) {
  return n === r || void 0 !== n && void 0 !== r && o(n[0], r[0]) && o(n[1], r[1]);
}

export { i as EPSILON, o as near, f as nearPair, r as theSame, t as theSameArray, e as theSamePair, u as theSamePath };